module.exports = __webpack_public_path__ + "img/watek_logo.7207bce9.jpg";